import * as React from "react";

export const BrandDataContext = React.createContext<any>({});
